import ProximaLink from './ProximaLink';

export default ProximaLink;
